module.exports = __webpack_public_path__ + "static/img/avatar_r_19.c1a71d33.png";